import { useState } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import { SlideComponentMultipleChoice, SlideComponentMultipleChoiceQuestionModel } from 'models/lesson/LessonModel';

const { v4: uuidv4 } = require('uuid');

const marginLeft = 100;
const marginTop = 200;

type MultpleChoiceQuestionModel = {
    questionText: string;
    choices: string[];
    answerIndex: number;
};

const GENERATE_TEXT_GENERIC_QUERY = gql`
    query GenTextGeneric($questionPrompt: String!) {
        generateTextGeneric(questionPrompt: $questionPrompt) {
            replyText
        }
    }
`;

export const useLessonsSlidePropsMultipleChoiceHook = (itemContent: SlideComponentMultipleChoice) => {
    const [loading, setLoading] = useState(false);
    const [genTextGeneric] = useLazyQuery(GENERATE_TEXT_GENERIC_QUERY, {
        fetchPolicy: 'no-cache',
    });

    const parseResultsMultipleChoice = (results: string) => {
        const blocks = results.split(/\n\s*\n/); // Split the text into blocks using blank lines as separators

        const parsedBlocks = blocks.map((block: string) => {
            const questionMatch = block.match(/^.+/);
            const questionText = questionMatch ? questionMatch[0].trim() : '';

            const choicesRegex = /([A-D]\).*[\r\n])/g;
            const choicesMatch = block.match(choicesRegex);
            const choices = choicesMatch ? choicesMatch.map((choice) => choice.replace(/[A-D]\)\s/, '').trim()) : [];

            const answerRegex = /答案：([A-D])\)/;
            const answerMatch = block.match(answerRegex);
            const answerIndex = answerMatch ? answerMatch[1].charCodeAt(0) - 'A'.charCodeAt(0) : -1;

            console.log('parseResultsMultipleChoice::{ questionText, choices, answerIndex }:', { questionText, choices, answerIndex });
            return { questionText, choices, answerIndex };
        });

        return parsedBlocks;
    };

    const getTextFromServerGeneric = async (questionPrompt: string) => {
        try {
            setLoading(true);
            const result = await genTextGeneric({
                variables: { questionPrompt },
            });

            let blocks = parseResultsMultipleChoice(result.data.generateTextGeneric.replyText);
            // 1. 這個筆盒的尺寸是多少？
            // A) 十厘米長、五厘米闊、三厘米高
            // B) 十厘米長、十厘米闊、五厘米高
            // C) 二十厘米長、十厘米闊、五厘米高
            // D) 二十厘米長、五厘米闊、十厘米高
            // 答案：C) 二十厘米長、十厘米闊、五厘米高
            UpdateQuestionArrayInfoMultipleChoice(blocks ?? []);
        } catch (err) {
            console.log('gen text error:', err);
        } finally {
            setLoading(false);
        }
    };

    const UpdateQuestionArrayInfoMultipleChoice = (data: MultpleChoiceQuestionModel[]) => {
        let newQuestion: SlideComponentMultipleChoiceQuestionModel[] = [];
        let i = 0;
        for (const question of data) {
            newQuestion.push({
                id: uuidv4(),
                choices: question.choices,
                answerIndex: question.answerIndex,
                questionText: question.questionText,
                pos: {
                    x: marginLeft + 400 * (i % 2),
                    y: marginTop + 100 * Math.floor(i / 2),
                },
            });
            i++;
        }

        itemContent.questions = newQuestion;
    };

    const deleteQuestionArrayInfo = (idx: number) => {
        const indexToDelete = idx; // delete the item at index 1
        const newQuestion = itemContent.questions.filter((item, index) => index !== indexToDelete);
        itemContent.questions = newQuestion;
    };

    const addQuestion = () => {
        let currentIdx = itemContent.questions.length;
        itemContent.questions.push({
            id: uuidv4(),
            answerIndex: 0,
            questionText: '',
            choices: ['', '', '', ''],
            pos: {
                x: marginLeft + 400 * (currentIdx % 2),
                y: marginTop + 100 * Math.floor(currentIdx / 2),
            },
        });
    };

    const addChoice = (questionIndex: number) => {
        if (itemContent.questions[questionIndex].choices.length < 5) {
            itemContent.questions[questionIndex].choices.push(''); // Add an empty string as a new choice
        }
    };

    const deleteChoice = (questionIndex: number, choiceIndex: number) => {
        if (itemContent.questions[questionIndex].choices.length > 2) {
            itemContent.questions[questionIndex].choices = itemContent.questions[questionIndex].choices.filter((_, index) => index !== choiceIndex);
        }
    };

    const questionFieldChange = (idx: number, textContent: string) => {
        itemContent.questions[idx].questionText = textContent;
    };
    const answerIndexChange = (idx: number, myAnswerIndex: number) => {
        itemContent.questions[idx].answerIndex = myAnswerIndex;
    };
    const choicesFieldChange = (idx: number, choiceIndex: number, choiceContent: string) => {
        itemContent.questions[idx].choices[choiceIndex] = choiceContent;
    };

    return {
        getTextFromServerGeneric,
        deleteQuestionArrayInfo,
        questionFieldChange,
        choicesFieldChange,
        answerIndexChange,
        loading,
        hasGenerated: itemContent.questions.length > 0,
        addQuestion,
        addChoice,
        deleteChoice,
    };
};
